module.exports = __webpack_public_path__ + "static/media/calendar.1bb2bd50.svg";